export interface DashboardItemModel {
  dashboardName: string;
  dashboardId: string;
  description?: string;
  dashboardMenuLabel: string;
  dashboardMenuIcon?: string;
  routerLink?: string;
  withoutQueryParams?: boolean;
  active: boolean;
  tenantId: string;
}

export interface DashboardListModel {
  tenantId: string;
  dashboards: DashboardItemModel[];
  count: number;
}
